export default "__VITE_ASSET__BTD39HT9__"